var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "../../UI/Icon/Icon", "./LiveLabel.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("../../UI/Icon/Icon"), require("./LiveLabel.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.Icon, global.LiveLabel);
    global.LiveLabel = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _Icon, _LiveLabel) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _Icon = _interopRequireDefault(_Icon);

  var LiveLabel = function LiveLabel(_ref) {
    var icon = _ref.icon,
        label = _ref.label,
        live = _ref.live,
        size = _ref.size;
    return /*#__PURE__*/_react.default.createElement(_LiveLabel.StyledLabel, {
      size: size
    }, /*#__PURE__*/_react.default.createElement(_LiveLabel.StyledLabelText, {
      live: live
    }, label), live && /*#__PURE__*/_react.default.createElement(_LiveLabel.StyledIcons, {
      "aria-hidden": "false"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "".concat(icon, "-1")
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "".concat(icon, "-2")
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "".concat(icon, "-3")
    })));
  };

  LiveLabel.propTypes = {
    label: _propTypes.default.string.isRequired,
    live: _propTypes.default.bool.isRequired,
    icon: _propTypes.default.string,
    size: _propTypes.default.oneOf(['small', 'medium', 'large'])
  };
  LiveLabel.defaultProps = {
    label: 'live',
    live: false,
    icon: 'arte-icon-concert-live',
    size: 'large'
  };
  var _default = LiveLabel;
  _exports.default = _default;
});